<script lang="ts">
  import Honeybadger from "$app/utils/honeybadger"
  import { Trash } from "lucide-svelte"
  import Autocomplete from "$app/components/Autocomplete.svelte"
  import { onboardingStore } from "../onboarding.svelte"
  import { appStore } from "$app/store.svelte"
  import { xhr } from "$app/utils"

  let props = $props()

  let {
    lineNumber,
    swot,
    ondelete,
    onupdate,
    onprocess
  }: {
    lineNumber: number
    swot: StatementTypeExt
    ondelete?: (swot: StatementTypeExt) => void
    onupdate?: (swot: StatementTypeExt) => void
    onprocess?: (valid: boolean) => void
  } = props

  let swots = (onboardingStore.swotAutocompleteOptions[
    onboardingStore.current_onboarding_step
  ] || []) as StatementTypeExt[]

  let form = $state({
    name: swot.name
  })
  let errors: any = $state({})
  let saving = $state(false)

  async function createStatement(): Promise<void> {
    errors = {}
    try {
      saving = true
      const resp = await xhr.post(
        `/plans/${appStore.plan.id}/statements.json`,
        {
          statement: {
            name: form.name,
            section_type: swot.section_type
          }
        }
      )
      onupdate({
        ...resp.data.statement,
        _selected: false,
        _valid: true
      })
    } catch (e) {
      if (e.response && e.response.data) {
        errors = { ...errors, ...e.response.data.errors }
        onupdate({ ...swot, _valid: false })
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
    } finally {
      saving = false
      onprocess(validValue())
    }
  }

  async function updateStatement(): Promise<void> {
    errors = {}
    try {
      onprocess(validValue())
      const resp = await xhr.put(
        `/plans/${appStore.plan.id}/statements/${swot.id}.json`,
        {
          statement: {
            name: form.name
          }
        }
      )

      onupdate({
        ...resp.data,
        _selected: false,
        _valid: true
      })
    } catch (e) {
      onupdate({ ...swot, _valid: false })
      if (e.response && e.response.data) {
        errors = { ...errors, ...e.response.data.errors }
      } else {
        if (typeof Honeybadger.notify !== "undefined") {
          Honeybadger.notify(e)
        }
      }
    } finally {
      saving = false
    }
  }

  function createOrUpdateStatement(field: string): void {
    if (swot.id) {
      updateStatement()
    } else if (!swot.id) {
      createStatement()
    }
  }

  function validValue(): boolean {
    return Object.keys(errors).length === 0 && !saving && !!swot.id
  }
</script>

<li class="px-2 py-2 flex gap-2" data-name="line-{lineNumber}">
  <div class="w-full">
    <Autocomplete
      items={swots}
      displayField="name"
      inputValue={swot.name}
      minChars={0}
      data-name="input-{lineNumber}"
      inputClass="w-full input focus:ring-2 focus:ring-blue-900"
      placeholder="Select or type to add {swot.section_type === 'Opportunity'
        ? 'an'
        : 'a'} {swot.section_type?.toLocaleLowerCase()}"
      onchange={(swot) => {
        form.name = swot.name || swot
        createOrUpdateStatement("name")
      }}
      onselected={async (swot) => {
        if (swot?.name) {
          form.name = swot.name
          createOrUpdateStatement("name")
        } else if (swot) {
          form.name = swot
          createOrUpdateStatement("name")
        }
      }}
    />
    {#if errors.name}
      <div class="flex gap-2">
        <div class="text-red-500 text-sm">
          {errors.name || ""}
        </div>
      </div>
    {/if}
  </div>
  <button
    class="text-white hover:text-red-500"
    title="Delete"
    type="button"
    onclick={() => ondelete(swot)}
  >
    <Trash />
  </button>
</li>
